import type { FC } from "react";

import {
  SHEET_FOOTER_CTAS_DEFAULTS,
  type TSheetFooterProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib/utils";
import { SheetFooterCtas } from "./SheetFooterCtas";

export const SheetFooter: FC<TSheetFooterProps> = (
  {
    className,
    ctas,
    align = SHEET_FOOTER_CTAS_DEFAULTS.align,
    ...props
  },
) => (
  <div
    data-component="SheetFooter"
    className={cn(
      "mt-auto",
      className,
    )}
    {...props}
  >
    <SheetFooterCtas align={align} ctas={ctas} />
  </div>
);

SheetFooter.displayName = "SheetFooter";
